import React from 'react'
import './Card.css'

export default ({ children }) => <div class="card">{children}</div>
